import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import moment from "moment";
import { Table, Tag, Button } from "antd";
import {
    PhoneOutlined,
    UserOutlined,
    ArrowUpOutlined,
    ArrowDownOutlined,
    CheckCircleOutlined,
    CloseCircleOutlined
} from "@ant-design/icons";

const dateFormat = "YYYY-MM-DD HH:mm:ss";

export default function ShowTTSLogTable({ data, sttBegin, sapxep, setSapxep }) {
    const user = useSelector((state) => state.loginReducer.user);
    const makeCall = useSelector((state) => state.jsSIPReducer?.makeCall);

    const [user_company_id, setUser_company_id] = useState(-1);

    useEffect(() => {
        const agent = user?.agents;
        if (agent && agent.length > 0) {
            setUser_company_id(agent[0].company_id);
        }
    }, [user]);

    const handleMakeCall = (callto) => {
        if (makeCall) {
            makeCall(callto);
        }
    };

    const columns = [
        {
            title: "STT",
            key: "stt",
            width: 70,
            align: "center",
            render: (text, record, index) => (sttBegin ? sttBegin : 1) + index,
        },
        {
            title: (
                <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                    <span>Thời gian</span>
                    <div style={{ display: "flex", flexDirection: "column", fontSize: "10px", lineHeight: 1, marginLeft: 8 }}>
                        <ArrowUpOutlined
                            style={{ cursor: "pointer", color: sapxep === "ASC" ? "#3b82f6" : "#bfdbfe" }}
                            title="Tăng dần"
                            onClick={() => setSapxep("ASC")}
                        />
                        <ArrowDownOutlined
                            style={{ cursor: "pointer", color: sapxep === "DESC" ? "#3b82f6" : "#bfdbfe" }}
                            title="Giảm dần"
                            onClick={() => setSapxep("DESC")}
                        />
                    </div>
                </div>
            ),
            dataIndex: "at_time",
            key: "at_time",
            width: 170,
            render: (text) => (
                <div className="tts-time-display">
                    <span>{moment(text).format(dateFormat)}</span>
                </div>
            ),
        },
        ...(user_company_id === 1 ? [{
            title: "Công ty",
            key: "company",
            width: 200,
            render: (text, record) => (
                <div>
                    <div style={{ fontWeight: 600, color: "#1e293b" }}>{record.company_name}</div>
                    {record.contactname && (
                        <div style={{ fontSize: "12px", color: "#64748b", marginTop: 4 }}>
                            <UserOutlined style={{ marginRight: 4 }} />
                            {record.contactname}
                        </div>
                    )}
                </div>
            )
        }] : []),
        {
            title: "Số điện thoại",
            dataIndex: "tel",
            key: "tel",
            width: 160,
            render: (text) => (
                <div className="tts-tel-container">
                    {makeCall ? (
                        <Button
                            className="tts-phone-btn"
                            icon={<PhoneOutlined />}
                            onClick={() => handleMakeCall(text)}
                            title="Nhấp để gọi"
                        />
                    ) : (
                        <PhoneOutlined style={{ color: "#94a3b8" }} />
                    )}
                    <span style={{ fontWeight: 600, fontSize: "14px", color: "#1e293b" }}>{text}</span>
                </div>
            ),
        },
        {
            title: "Trạng thái TTS",
            dataIndex: "playstatus",
            key: "playstatus",
            width: 140,
            render: (text) => {
                let color = "blue";
                let statusLabel = text || "N/A";

                const normText = (text || "").toUpperCase();
                if (normText.includes("SUCCESS") || normText.includes("PLAYED") || normText === "1" || normText.includes("ĐÃ PHÁT") || normText === "PLAY") {
                    color = "success";
                    statusLabel = "Đã phát";
                } else if (normText.includes("FAIL") || normText.includes("ERROR") || normText === "0" || normText.includes("LỖI")) {
                    color = "error";
                    statusLabel = "Lỗi";
                } else if (normText.includes("PLAYING") || normText.includes("ĐANG PHÁT")) {
                    color = "warning";
                    statusLabel = "Đang phát";
                }

                return <Tag color={color} style={{ fontWeight: 600, padding: "2px 8px", borderRadius: "4px" }}>{statusLabel}</Tag>;
            },
        },
        {
            title: "Thông tin & Tiến trình cuộc gọi",
            key: "tts_details",
            render: (text, record) => (
                <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
                    <div style={{ display: "flex", gap: 12, flexWrap: "wrap", alignItems: "center" }}>
                        {record.cnh_id && (
                            <div>
                                <span className="tts-id-label" style={{ marginRight: 4 }}>ID:</span>
                                <span className="tts-id-val">{record.cnh_id}</span>
                            </div>
                        )}
                        <div className="tts-content-preview" style={{ maxWidth: "100%" }}>
                            {record.content}
                        </div>
                        <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
                            <span style={{ fontSize: "12px", color: "#64748b" }}>Tiếp tục sau TTS:</span>
                            {record.iscontinue_afterplaytts === 1 ? (
                                <Tag color="green" style={{ margin: 0 }}><CheckCircleOutlined style={{ marginRight: 2 }} />Có</Tag>
                            ) : (
                                <Tag color="red" style={{ margin: 0 }}><CloseCircleOutlined style={{ marginRight: 2 }} />Không</Tag>
                            )}
                        </div>
                        <br />
                        <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
                            <span style={{ fontSize: "12px", color: "#64748b" }}>Gặp ĐTV (Agent):</span>
                            {record.isconnected_toagent === 1 ? (
                                <Tag color="green" style={{ margin: 0 }}><CheckCircleOutlined style={{ marginRight: 2 }} />Có</Tag>
                            ) : (
                                <Tag color="red" style={{ margin: 0 }}><CloseCircleOutlined style={{ marginRight: 2 }} />Không</Tag>
                            )}
                        </div>
                    </div>


                </div>
            ),
        },
    ];

    return (
        <div>
            <Table
                className="tts-table"
                dataSource={data}
                columns={columns}
                rowKey="id"
                pagination={false}
                bordered
            />
        </div>
    );
}